/* eslint-disable camelcase */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// eslint-disable-next-line import/no-unresolved
import deviceImage from 'url:~/src/assets/DeviceImage2.png';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 12,
    color: '#1e3f9e',
    maxWidth: 650,
  },
}));

const Cable = () => {
  const classes = useStyles();

  return (
    <div>
      <h4 className={classes.title}>Remove battery from monitor if present.</h4>
      <h4 className={classes.title}>
        Take the 3-pronged cover off of the UART-USB cable. In the bottom-left corner of the monitor, insert the cable
        into the monitor to be added to the network. Re-attatch the 3-pronged cover to the cable on the backside of the
        circuit board, securing the cable and the monitor together.
      </h4>
      <h4 className={classes.title}>Press the power button to turn on the monitor and click CONTINUE.</h4>
      <img src={deviceImage} alt="Monitor Internal Diagram" />
    </div>
  );
};

export default Cable;
